export const SET_FETCHING_REGISTRATION_SETTINGS = 'SET_FETCHING_REGISTRATION_SETTINGS';
export const SET_FETCH_REGISTRATION_SETTINGS_ERROR = 'SET_FETCH_REGISTRATION_SETTINGS_ERROR';
export const SET_POST_REGISTRATION_SETTINGS_ERROR = 'SET_POST_REGISTRATION_SETTINGS_ERROR';